import { React, useState, useEffect, useRef } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import QRScannerView from "./QRScannerView";
import QRCodeResultView from "./QRCodeResultView";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function QRCodeReaderMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "QR Code Scanner, Reader Free",
  };

  //scan result
  const [scanResult, setScanResult] = useState({ error: null, result: [] });

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/qr_scanner", title: "Scan QR Codes" },
    data2: { link: "/qr_scanner", title: "QR Scanner Free" },
    data3: { link: "/qr_scanner", title: "Barcode Scanner Free" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageContext.Provider
      value={{
        setScanResult,
        scanResult,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Scan QR codes & Barcodes online instantly. Read URLs, text, and more with our fast, secure, and easy-to-use QR code scanner tool."
      ></meta>
      <meta
        name="keywords"
        content="qr code scanner, scan qr code online, qr reader, online qr code scanner, qr code reader tool, read qr code, scan qr code, qr code scanning tool, qr code reader online, qr code scanner app, qr code scanner free, qr code reader for website, qr code reader online free, qr code scanning online, qr code reader fast, barcode scanner, scan barcodes,"
      ></meta>

      {/* page content */}
      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={false} />
        {/* Qr scanner */}
        <QRScannerView />
        {/* Result View */}
        <QRCodeResultView />
        {/* Mid Section */}
        <MiscPageMidSection description="Our QR Code Scanner website is a fast, secure, and easy-to-use solution designed to scan QR codes instantly using your device camera or uploaded images. This online QR code scanner supports all QR code types, including website URLs, Wi-Fi credentials, contact details, text, email, SMS, payment links, and social media profiles, making it ideal for personal and business use. With a clean and responsive interface, users can scan QR code online on mobile, tablet, or desktop without installing any app. The website ensures complete privacy, as scanned data is processed securely and never stored on our servers. Whether you need a free QR code scanner for quick access to information, digital payments, menus, or event check-ins, this QR scanner online delivers accurate and real-time results. Optimized for speed and compatibility, our QR code reader works smoothly across all modern browsers and operating systems, providing a reliable and convenient way to scan QR codes online anytime, anywhere." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Select",
            step2: "Offline",
            step3: "Scan",
            step4: "View",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="QR Code Scanner"
          why_use={[
            {
              title: "Instant Access to Digital Information",
              description:
                "Our QR code scanner allows users to instantly open websites, documents, payment links, and contact details by scanning a code.",
            },
            {
              title: "Fast and Contactless Payments",
              description:
                "Using a QR code scanner enables quick and secure contactless payments, making transactions simple and convenient.",
            },
            {
              title: "Quick Product Identification",
              description:
                "This barcode scanner helps identify products instantly by scanning barcodes for pricing, inventory, and product details.",
            },
            {
              title: "Save Time and Increase Efficiency",
              description:
                "Our QR code scanner and barcode scanner reduce manual data entry, helping users complete tasks faster.",
            },
            {
              title: "Essential for Business and Retail Use",
              description:
                "Businesses rely on barcode scanner tools for inventory management, billing, and stock tracking.",
            },
            {
              title: "Offline-Friendly Code Scanning",
              description:
                "Many QR code scanner tools work offline after scanning, allowing users to access saved information later.",
            },
            {
              title: "Support Marketing and Promotions",
              description:
                "Companies use QR code scanner technology to connect customers to offers, websites, and promotional campaigns.",
            },
            {
              title: "Improve Accuracy and Reduce Errors",
              description:
                "Using a barcode scanner minimizes human errors compared to manual entry of product or item codes.",
            },
            {
              title: "Useful for Education and Events",
              description:
                "Schools and event organizers use QR code scanner and barcode scanner tools for attendance, tickets, and resource access.",
            },
          ]}
        />
        {/* FAQ */}
        <MiscFAQ
          faq_list={[
            {
              title: "What is a QR code reader?",
              description:
                "A QR code reader is a tool that scans and decodes QR codes to reveal information such as website URLs, text, contact details, email addresses, phone numbers, and Wi-Fi information. ShivaPDF helps you read QR codes quickly and easily.",
            },
            {
              title: "How can I read a QR code for free?",
              description:
                "You can use a free QR code reader on ShivaPDF.com to decode a QR code from a supported image. Open the QR code reader, select or upload your image if required, and view the decoded information.",
            },
            {
              title: "Can I scan a QR code offline?",
              description:
                "Yes, if the QR code reader is implemented to process images directly on your device, you can scan QR codes without an internet connection after the tool has loaded. Check that your browser and the tool support offline processing.",
            },
            {
              title: "Does ShivaPDF QR Code Reader upload my images?",
              description:
                "A locally processed QR code reader can decode images directly in your browser without sending them to a server. Check the tool's implementation and privacy policy to confirm how your images are handled.",
            },
            {
              title: "How do I read a QR code from an image?",
              description:
                "Open the QR code reader, choose a supported image containing a QR code, and start decoding. The tool can display the information embedded in the code when the image is clear and the QR code is readable.",
            },
            {
              title: "Can I read a QR code from a screenshot?",
              description:
                "Yes, if the screenshot contains a clear, complete QR code, a QR code reader can decode it. Select the screenshot from your device and make sure the QR code is not cropped, blurred, or obscured.",
            },
            {
              title: "Can I scan a QR code from a photo?",
              description:
                "Yes. You can read a QR code saved in a photo or image file using a compatible QR code reader. For the best results, use a clear image with the entire QR code visible.",
            },
            {
              title: "What information can a QR code reader detect?",
              description:
                "A QR code may contain website links, plain text, email addresses, phone numbers, contact information, Wi-Fi details, or other encoded data. The information displayed depends on the type of QR code you scan.",
            },
            {
              title: "Can I read a QR code without installing an app?",
              description:
                "Yes, a browser-based QR code reader can let you decode QR codes without installing a separate application. Visit ShivaPDF.com using a compatible browser and use the QR code reader if it is available for your device.",
            },
            {
              title: "Is the ShivaPDF QR code reader free?",
              description:
                "ShivaPDF aims to make useful online tools accessible and easy to use. Check the QR code reader page for current usage limits, available features, and any restrictions.",
            },
            {
              title: "Can I read QR codes on my mobile phone?",
              description:
                "Yes, a mobile-friendly QR code reader can work in a browser on compatible iPhone and Android devices. Open ShivaPDF.com on your phone and select a QR code image if the tool supports image-based scanning.",
            },
            {
              title: "Can I read QR codes on a computer?",
              description:
                "Yes, you can use a compatible desktop or laptop browser to decode QR codes from supported image files. This is useful when a QR code is saved in a screenshot, document, or photo on your computer.",
            },
            {
              title: "Can I read a QR code from a PDF file?",
              description:
                "If your QR code is inside a PDF, you may need to save or capture the relevant page as an image first. Then use a QR code reader that supports image input to decode the QR code.",
            },
            {
              title: "Why is my QR code not being detected?",
              description:
                "A QR code may fail to scan if the image is blurry, too small, cropped, distorted, or poorly contrasted. Try using a higher-resolution image, keeping the full code visible, and avoiding glare or obstructions.",
            },
            {
              title: "Can a QR code reader scan damaged QR codes?",
              description:
                "Some QR codes can still be decoded when partially damaged because QR codes include error correction. However, a heavily damaged, obscured, or distorted code may not be readable.",
            },
            {
              title: "Can I read a QR code without a camera?",
              description:
                "Yes, if the QR code reader supports image files, you can decode a saved QR code image without using your camera. Choose a photo, screenshot, or other supported image containing the code.",
            },
            {
              title: "Can I scan a QR code from another screen?",
              description:
                "If you have a QR code displayed on another device, you can take a screenshot or save the image and use an image-based QR code reader. Alternatively, use your phone's camera if it supports QR code scanning.",
            },
            {
              title: "Does a QR code reader need an internet connection?",
              description:
                "Some QR code readers require an internet connection to load or process QR codes, while locally processed readers may work offline once loaded. Internet access may still be needed to open a website linked from a QR code.",
            },
            {
              title: "Can I open a website after scanning its QR code?",
              description:
                "If the QR code contains a website URL, the reader can display the decoded link. Review the address before opening it, especially if the QR code comes from an unfamiliar source.",
            },
            {
              title: "Is it safe to scan QR codes?",
              description:
                "Reading a QR code is generally straightforward, but the code may contain a suspicious link or misleading information. Check the decoded URL before visiting it, downloading files, or entering personal or payment details.",
            },
            {
              title: "Can a QR code reader decode Wi-Fi QR codes?",
              description:
                "A compatible QR code reader can identify Wi-Fi configuration data embedded in a QR code. Whether it displays the network name and other details depends on the reader's supported formats.",
            },
            {
              title: "Can I read a QR code without creating an account?",
              description:
                "A QR code reader can be offered without registration, allowing users to decode supported QR code images directly. Check ShivaPDF's current tool page for any account or usage requirements.",
            },
            {
              title: "Which image formats can I use to read QR codes?",
              description:
                "Supported image formats depend on the QR code reader. Common formats for QR code images include PNG and JPG or JPEG. Check the tool's file picker for the formats it accepts.",
            },
            {
              title: "Why should I use ShivaPDF's QR code reader?",
              description:
                "ShivaPDF provides browser-based PDF and utility tools designed to make everyday tasks easier. Use its QR code reader to decode supported QR code images without installing a separate application, subject to the tool's available features.",
            },
          ]} />
        {/* Download on Appsroe */}
        <MiscDownloadOnAppStore
          id={`https://apps.apple.com/app/id${1189800081}`}
        />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Recommended Tools */}
        <MiscRecommendedPages />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default QRCodeReaderMain;
